// T31 glue — wraps `useTemporalReplay`'s play/pause with the mandatory toggle-both-ways analytics
// event. Split out of `SpatialResultsMapPanel.tsx` to help keep that file under the 200-line cap.
// (A7/NG9's metadata-only candidate-column pick happens in the panel BEFORE this hook runs — see
// `findCandidateTimeColumnId` — because it must be known before the windowed row fetch, while this
// hook consumes the ALREADY-fetched rows.)

import { useCallback } from 'react';
import { useAnalytics } from '../../../../core/analytics';
import { useTemporalReplay, type TemporalReplay, type TemporalReplayColumn } from './useTemporalReplay';

export type SpatialResultsReplay = TemporalReplay & {
  onPlay: () => void;
  onPause: () => void;
};

export function useSpatialResultsMapReplay(
  rows: Record<string, unknown>[],
  columns: TemporalReplayColumn[],
): SpatialResultsReplay {
  const { track } = useAnalytics();
  const replay = useTemporalReplay(rows, columns);

  const onPlay = useCallback(() => {
    track('feature:spatial_replay', { enabled: true });
    replay.play();
  }, [replay, track]);
  const onPause = useCallback(() => {
    track('feature:spatial_replay', { enabled: false });
    replay.pause();
  }, [replay, track]);

  return { ...replay, onPlay, onPause };
}
